var TextAlign;
(function (TextAlign) {
    TextAlign["left"] = "left";
    TextAlign["right"] = "right";
    TextAlign["center"] = "center";
})(TextAlign || (TextAlign = {}));

export { TextAlign };
